/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as ConsentRouteImport } from './routes/consent'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as AuthenticatedSlugRouteImport } from './routes/_authenticated.$slug'
import { Route as AuthenticatedInvitesRouteImport } from './routes/_authenticated.invites'
import { Route as AuthenticatedOnboardingRouteImport } from './routes/_authenticated.onboarding'
import { Route as ITokenRouteImport } from './routes/i.$token'
import { Route as JoinTokenRouteImport } from './routes/join.$token'
import { Route as UnsubscribeTokenRouteImport } from './routes/unsubscribe.$token'
import { Route as AuthenticatedSlugIndexRouteImport } from './routes/_authenticated.$slug.index'
import { Route as AuthenticatedSlugAttendanceRouteImport } from './routes/_authenticated.$slug.attendance'
import { Route as AuthenticatedSlugDeletedRouteImport } from './routes/_authenticated.$slug.deleted'
import { Route as AuthenticatedSlugInboxRouteImport } from './routes/_authenticated.$slug.inbox'
import { Route as AuthenticatedSlugSearchRouteImport } from './routes/_authenticated.$slug.search'
import { Route as AuthenticatedSlugTasksRouteImport } from './routes/_authenticated.$slug.tasks'
import { Route as AuthenticatedSlugTeamRouteImport } from './routes/_authenticated.$slug.team'
import { Route as AuthenticatedCompaniesNewRouteImport } from './routes/_authenticated.companies.new'
import { Route as AuthenticatedOnboardingInviteRouteImport } from './routes/_authenticated.onboarding.invite'
import { Route as AuthenticatedOnboardingProfileRouteImport } from './routes/_authenticated.onboarding.profile'
import { Route as AuthenticatedSlugAttendanceIndexRouteImport } from './routes/_authenticated.$slug.attendance.index'
import { Route as AuthenticatedSlugAttendanceLeaveRouteImport } from './routes/_authenticated.$slug.attendance.leave'
import { Route as AuthenticatedSlugAttendanceMonthRouteImport } from './routes/_authenticated.$slug.attendance.month'
import { Route as AuthenticatedSlugAttendanceMyMonthRouteImport } from './routes/_authenticated.$slug.attendance.my-month'
import { Route as AuthenticatedSlugInvoicesIndexRouteImport } from './routes/_authenticated.$slug.invoices.index'
import { Route as AuthenticatedSlugInvoicesInvoiceIdRouteImport } from './routes/_authenticated.$slug.invoices.$invoiceId'
import { Route as AuthenticatedSlugNotesIndexRouteImport } from './routes/_authenticated.$slug.notes.index'
import { Route as AuthenticatedSlugNotesNoteIdRouteImport } from './routes/_authenticated.$slug.notes.$noteId'
import { Route as AuthenticatedSlugPayslipsIndexRouteImport } from './routes/_authenticated.$slug.payslips.index'
import { Route as AuthenticatedSlugPayslipsPayslipIdRouteImport } from './routes/_authenticated.$slug.payslips.$payslipId'
import { Route as AuthenticatedSlugPayslipsMineRouteImport } from './routes/_authenticated.$slug.payslips.mine'
import { Route as AuthenticatedSlugProjectsIndexRouteImport } from './routes/_authenticated.$slug.projects.index'
import { Route as AuthenticatedSlugProjectsProjectIdRouteImport } from './routes/_authenticated.$slug.projects.$projectId'
import { Route as AuthenticatedSlugTeamIndexRouteImport } from './routes/_authenticated.$slug.team.index'
import { Route as AuthenticatedSlugTeamPeopleRouteImport } from './routes/_authenticated.$slug.team.people'
import { Route as AuthenticatedSlugTeamPersonIdRouteImport } from './routes/_authenticated.$slug.team_.$personId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsentRoute = ConsentRouteImport.update({
  id: '/consent',
  path: '/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSlugRoute = AuthenticatedSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInvitesRoute = AuthenticatedInvitesRouteImport.update({
  id: '/invites',
  path: '/invites',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const ITokenRoute = ITokenRouteImport.update({
  id: '/i/$token',
  path: '/i/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinTokenRoute = JoinTokenRouteImport.update({
  id: '/join/$token',
  path: '/join/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const UnsubscribeTokenRoute = UnsubscribeTokenRouteImport.update({
  id: '/unsubscribe/$token',
  path: '/unsubscribe/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSlugIndexRoute = AuthenticatedSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedSlugRoute,
} as any)
const AuthenticatedSlugAttendanceRoute =
  AuthenticatedSlugAttendanceRouteImport.update({
    id: '/attendance',
    path: '/attendance',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugDeletedRoute =
  AuthenticatedSlugDeletedRouteImport.update({
    id: '/deleted',
    path: '/deleted',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugInboxRoute = AuthenticatedSlugInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AuthenticatedSlugRoute,
} as any)
const AuthenticatedSlugSearchRoute = AuthenticatedSlugSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AuthenticatedSlugRoute,
} as any)
const AuthenticatedSlugTasksRoute = AuthenticatedSlugTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AuthenticatedSlugRoute,
} as any)
const AuthenticatedSlugTeamRoute = AuthenticatedSlugTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AuthenticatedSlugRoute,
} as any)
const AuthenticatedCompaniesNewRoute =
  AuthenticatedCompaniesNewRouteImport.update({
    id: '/companies/new',
    path: '/companies/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOnboardingInviteRoute =
  AuthenticatedOnboardingInviteRouteImport.update({
    id: '/invite',
    path: '/invite',
    getParentRoute: () => AuthenticatedOnboardingRoute,
  } as any)
const AuthenticatedOnboardingProfileRoute =
  AuthenticatedOnboardingProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedOnboardingRoute,
  } as any)
const AuthenticatedSlugAttendanceIndexRoute =
  AuthenticatedSlugAttendanceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSlugAttendanceRoute,
  } as any)
const AuthenticatedSlugAttendanceLeaveRoute =
  AuthenticatedSlugAttendanceLeaveRouteImport.update({
    id: '/leave',
    path: '/leave',
    getParentRoute: () => AuthenticatedSlugAttendanceRoute,
  } as any)
const AuthenticatedSlugAttendanceMonthRoute =
  AuthenticatedSlugAttendanceMonthRouteImport.update({
    id: '/month',
    path: '/month',
    getParentRoute: () => AuthenticatedSlugAttendanceRoute,
  } as any)
const AuthenticatedSlugAttendanceMyMonthRoute =
  AuthenticatedSlugAttendanceMyMonthRouteImport.update({
    id: '/my-month',
    path: '/my-month',
    getParentRoute: () => AuthenticatedSlugAttendanceRoute,
  } as any)
const AuthenticatedSlugInvoicesIndexRoute =
  AuthenticatedSlugInvoicesIndexRouteImport.update({
    id: '/invoices/',
    path: '/invoices/',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugInvoicesInvoiceIdRoute =
  AuthenticatedSlugInvoicesInvoiceIdRouteImport.update({
    id: '/invoices/$invoiceId',
    path: '/invoices/$invoiceId',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugNotesIndexRoute =
  AuthenticatedSlugNotesIndexRouteImport.update({
    id: '/notes/',
    path: '/notes/',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugNotesNoteIdRoute =
  AuthenticatedSlugNotesNoteIdRouteImport.update({
    id: '/notes/$noteId',
    path: '/notes/$noteId',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugPayslipsIndexRoute =
  AuthenticatedSlugPayslipsIndexRouteImport.update({
    id: '/payslips/',
    path: '/payslips/',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugPayslipsPayslipIdRoute =
  AuthenticatedSlugPayslipsPayslipIdRouteImport.update({
    id: '/payslips/$payslipId',
    path: '/payslips/$payslipId',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugPayslipsMineRoute =
  AuthenticatedSlugPayslipsMineRouteImport.update({
    id: '/payslips/mine',
    path: '/payslips/mine',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugProjectsIndexRoute =
  AuthenticatedSlugProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugProjectsProjectIdRoute =
  AuthenticatedSlugProjectsProjectIdRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)
const AuthenticatedSlugTeamIndexRoute =
  AuthenticatedSlugTeamIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSlugTeamRoute,
  } as any)
const AuthenticatedSlugTeamPeopleRoute =
  AuthenticatedSlugTeamPeopleRouteImport.update({
    id: '/people',
    path: '/people',
    getParentRoute: () => AuthenticatedSlugTeamRoute,
  } as any)
const AuthenticatedSlugTeamPersonIdRoute =
  AuthenticatedSlugTeamPersonIdRouteImport.update({
    id: '/team_/$personId',
    path: '/team/$personId',
    getParentRoute: () => AuthenticatedSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/consent': typeof ConsentRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/$slug': typeof AuthenticatedSlugRouteWithChildren
  '/invites': typeof AuthenticatedInvitesRoute
  '/onboarding': typeof AuthenticatedOnboardingRouteWithChildren
  '/i/$token': typeof ITokenRoute
  '/join/$token': typeof JoinTokenRoute
  '/unsubscribe/$token': typeof UnsubscribeTokenRoute
  '/$slug/attendance': typeof AuthenticatedSlugAttendanceRouteWithChildren
  '/$slug/deleted': typeof AuthenticatedSlugDeletedRoute
  '/$slug/inbox': typeof AuthenticatedSlugInboxRoute
  '/$slug/search': typeof AuthenticatedSlugSearchRoute
  '/$slug/tasks': typeof AuthenticatedSlugTasksRoute
  '/$slug/team': typeof AuthenticatedSlugTeamRouteWithChildren
  '/companies/new': typeof AuthenticatedCompaniesNewRoute
  '/onboarding/invite': typeof AuthenticatedOnboardingInviteRoute
  '/onboarding/profile': typeof AuthenticatedOnboardingProfileRoute
  '/$slug/': typeof AuthenticatedSlugIndexRoute
  '/$slug/attendance/leave': typeof AuthenticatedSlugAttendanceLeaveRoute
  '/$slug/attendance/month': typeof AuthenticatedSlugAttendanceMonthRoute
  '/$slug/attendance/my-month': typeof AuthenticatedSlugAttendanceMyMonthRoute
  '/$slug/invoices/$invoiceId': typeof AuthenticatedSlugInvoicesInvoiceIdRoute
  '/$slug/notes/$noteId': typeof AuthenticatedSlugNotesNoteIdRoute
  '/$slug/payslips/$payslipId': typeof AuthenticatedSlugPayslipsPayslipIdRoute
  '/$slug/payslips/mine': typeof AuthenticatedSlugPayslipsMineRoute
  '/$slug/projects/$projectId': typeof AuthenticatedSlugProjectsProjectIdRoute
  '/$slug/team/people': typeof AuthenticatedSlugTeamPeopleRoute
  '/$slug/team/$personId': typeof AuthenticatedSlugTeamPersonIdRoute
  '/$slug/attendance/': typeof AuthenticatedSlugAttendanceIndexRoute
  '/$slug/invoices/': typeof AuthenticatedSlugInvoicesIndexRoute
  '/$slug/notes/': typeof AuthenticatedSlugNotesIndexRoute
  '/$slug/payslips/': typeof AuthenticatedSlugPayslipsIndexRoute
  '/$slug/projects/': typeof AuthenticatedSlugProjectsIndexRoute
  '/$slug/team/': typeof AuthenticatedSlugTeamIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/consent': typeof ConsentRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/invites': typeof AuthenticatedInvitesRoute
  '/onboarding': typeof AuthenticatedOnboardingRouteWithChildren
  '/i/$token': typeof ITokenRoute
  '/join/$token': typeof JoinTokenRoute
  '/unsubscribe/$token': typeof UnsubscribeTokenRoute
  '/$slug/deleted': typeof AuthenticatedSlugDeletedRoute
  '/$slug/inbox': typeof AuthenticatedSlugInboxRoute
  '/$slug/search': typeof AuthenticatedSlugSearchRoute
  '/$slug/tasks': typeof AuthenticatedSlugTasksRoute
  '/companies/new': typeof AuthenticatedCompaniesNewRoute
  '/onboarding/invite': typeof AuthenticatedOnboardingInviteRoute
  '/onboarding/profile': typeof AuthenticatedOnboardingProfileRoute
  '/$slug': typeof AuthenticatedSlugIndexRoute
  '/$slug/attendance/leave': typeof AuthenticatedSlugAttendanceLeaveRoute
  '/$slug/attendance/month': typeof AuthenticatedSlugAttendanceMonthRoute
  '/$slug/attendance/my-month': typeof AuthenticatedSlugAttendanceMyMonthRoute
  '/$slug/invoices/$invoiceId': typeof AuthenticatedSlugInvoicesInvoiceIdRoute
  '/$slug/notes/$noteId': typeof AuthenticatedSlugNotesNoteIdRoute
  '/$slug/payslips/$payslipId': typeof AuthenticatedSlugPayslipsPayslipIdRoute
  '/$slug/payslips/mine': typeof AuthenticatedSlugPayslipsMineRoute
  '/$slug/projects/$projectId': typeof AuthenticatedSlugProjectsProjectIdRoute
  '/$slug/team/people': typeof AuthenticatedSlugTeamPeopleRoute
  '/$slug/team/$personId': typeof AuthenticatedSlugTeamPersonIdRoute
  '/$slug/attendance': typeof AuthenticatedSlugAttendanceIndexRoute
  '/$slug/invoices': typeof AuthenticatedSlugInvoicesIndexRoute
  '/$slug/notes': typeof AuthenticatedSlugNotesIndexRoute
  '/$slug/payslips': typeof AuthenticatedSlugPayslipsIndexRoute
  '/$slug/projects': typeof AuthenticatedSlugProjectsIndexRoute
  '/$slug/team': typeof AuthenticatedSlugTeamIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/consent': typeof ConsentRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/_authenticated/$slug': typeof AuthenticatedSlugRouteWithChildren
  '/_authenticated/invites': typeof AuthenticatedInvitesRoute
  '/_authenticated/onboarding': typeof AuthenticatedOnboardingRouteWithChildren
  '/i/$token': typeof ITokenRoute
  '/join/$token': typeof JoinTokenRoute
  '/unsubscribe/$token': typeof UnsubscribeTokenRoute
  '/_authenticated/$slug/attendance': typeof AuthenticatedSlugAttendanceRouteWithChildren
  '/_authenticated/$slug/deleted': typeof AuthenticatedSlugDeletedRoute
  '/_authenticated/$slug/inbox': typeof AuthenticatedSlugInboxRoute
  '/_authenticated/$slug/search': typeof AuthenticatedSlugSearchRoute
  '/_authenticated/$slug/tasks': typeof AuthenticatedSlugTasksRoute
  '/_authenticated/$slug/team': typeof AuthenticatedSlugTeamRouteWithChildren
  '/_authenticated/companies/new': typeof AuthenticatedCompaniesNewRoute
  '/_authenticated/onboarding/invite': typeof AuthenticatedOnboardingInviteRoute
  '/_authenticated/onboarding/profile': typeof AuthenticatedOnboardingProfileRoute
  '/_authenticated/$slug/': typeof AuthenticatedSlugIndexRoute
  '/_authenticated/$slug/attendance/leave': typeof AuthenticatedSlugAttendanceLeaveRoute
  '/_authenticated/$slug/attendance/month': typeof AuthenticatedSlugAttendanceMonthRoute
  '/_authenticated/$slug/attendance/my-month': typeof AuthenticatedSlugAttendanceMyMonthRoute
  '/_authenticated/$slug/invoices/$invoiceId': typeof AuthenticatedSlugInvoicesInvoiceIdRoute
  '/_authenticated/$slug/notes/$noteId': typeof AuthenticatedSlugNotesNoteIdRoute
  '/_authenticated/$slug/payslips/$payslipId': typeof AuthenticatedSlugPayslipsPayslipIdRoute
  '/_authenticated/$slug/payslips/mine': typeof AuthenticatedSlugPayslipsMineRoute
  '/_authenticated/$slug/projects/$projectId': typeof AuthenticatedSlugProjectsProjectIdRoute
  '/_authenticated/$slug/team/people': typeof AuthenticatedSlugTeamPeopleRoute
  '/_authenticated/$slug/team_/$personId': typeof AuthenticatedSlugTeamPersonIdRoute
  '/_authenticated/$slug/attendance/': typeof AuthenticatedSlugAttendanceIndexRoute
  '/_authenticated/$slug/invoices/': typeof AuthenticatedSlugInvoicesIndexRoute
  '/_authenticated/$slug/notes/': typeof AuthenticatedSlugNotesIndexRoute
  '/_authenticated/$slug/payslips/': typeof AuthenticatedSlugPayslipsIndexRoute
  '/_authenticated/$slug/projects/': typeof AuthenticatedSlugProjectsIndexRoute
  '/_authenticated/$slug/team/': typeof AuthenticatedSlugTeamIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/consent'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/$slug'
    | '/invites'
    | '/onboarding'
    | '/i/$token'
    | '/join/$token'
    | '/unsubscribe/$token'
    | '/$slug/attendance'
    | '/$slug/deleted'
    | '/$slug/inbox'
    | '/$slug/search'
    | '/$slug/tasks'
    | '/$slug/team'
    | '/companies/new'
    | '/onboarding/invite'
    | '/onboarding/profile'
    | '/$slug/'
    | '/$slug/attendance/leave'
    | '/$slug/attendance/month'
    | '/$slug/attendance/my-month'
    | '/$slug/invoices/$invoiceId'
    | '/$slug/notes/$noteId'
    | '/$slug/payslips/$payslipId'
    | '/$slug/payslips/mine'
    | '/$slug/projects/$projectId'
    | '/$slug/team/people'
    | '/$slug/team/$personId'
    | '/$slug/attendance/'
    | '/$slug/invoices/'
    | '/$slug/notes/'
    | '/$slug/payslips/'
    | '/$slug/projects/'
    | '/$slug/team/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/consent'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/invites'
    | '/onboarding'
    | '/i/$token'
    | '/join/$token'
    | '/unsubscribe/$token'
    | '/$slug/deleted'
    | '/$slug/inbox'
    | '/$slug/search'
    | '/$slug/tasks'
    | '/companies/new'
    | '/onboarding/invite'
    | '/onboarding/profile'
    | '/$slug'
    | '/$slug/attendance/leave'
    | '/$slug/attendance/month'
    | '/$slug/attendance/my-month'
    | '/$slug/invoices/$invoiceId'
    | '/$slug/notes/$noteId'
    | '/$slug/payslips/$payslipId'
    | '/$slug/payslips/mine'
    | '/$slug/projects/$projectId'
    | '/$slug/team/people'
    | '/$slug/team/$personId'
    | '/$slug/attendance'
    | '/$slug/invoices'
    | '/$slug/notes'
    | '/$slug/payslips'
    | '/$slug/projects'
    | '/$slug/team'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/consent'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/_authenticated/$slug'
    | '/_authenticated/invites'
    | '/_authenticated/onboarding'
    | '/i/$token'
    | '/join/$token'
    | '/unsubscribe/$token'
    | '/_authenticated/$slug/attendance'
    | '/_authenticated/$slug/deleted'
    | '/_authenticated/$slug/inbox'
    | '/_authenticated/$slug/search'
    | '/_authenticated/$slug/tasks'
    | '/_authenticated/$slug/team'
    | '/_authenticated/companies/new'
    | '/_authenticated/onboarding/invite'
    | '/_authenticated/onboarding/profile'
    | '/_authenticated/$slug/'
    | '/_authenticated/$slug/attendance/leave'
    | '/_authenticated/$slug/attendance/month'
    | '/_authenticated/$slug/attendance/my-month'
    | '/_authenticated/$slug/invoices/$invoiceId'
    | '/_authenticated/$slug/notes/$noteId'
    | '/_authenticated/$slug/payslips/$payslipId'
    | '/_authenticated/$slug/payslips/mine'
    | '/_authenticated/$slug/projects/$projectId'
    | '/_authenticated/$slug/team/people'
    | '/_authenticated/$slug/team_/$personId'
    | '/_authenticated/$slug/attendance/'
    | '/_authenticated/$slug/invoices/'
    | '/_authenticated/$slug/notes/'
    | '/_authenticated/$slug/payslips/'
    | '/_authenticated/$slug/projects/'
    | '/_authenticated/$slug/team/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ConsentRoute: typeof ConsentRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  ITokenRoute: typeof ITokenRoute
  JoinTokenRoute: typeof JoinTokenRoute
  UnsubscribeTokenRoute: typeof UnsubscribeTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/consent': {
      id: '/consent'
      path: '/consent'
      fullPath: '/consent'
      preLoaderRoute: typeof ConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/$slug': {
      id: '/_authenticated/$slug'
      path: '/$slug'
      fullPath: '/$slug'
      preLoaderRoute: typeof AuthenticatedSlugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/invites': {
      id: '/_authenticated/invites'
      path: '/invites'
      fullPath: '/invites'
      preLoaderRoute: typeof AuthenticatedInvitesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/onboarding': {
      id: '/_authenticated/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthenticatedOnboardingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/i/$token': {
      id: '/i/$token'
      path: '/i/$token'
      fullPath: '/i/$token'
      preLoaderRoute: typeof ITokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join/$token': {
      id: '/join/$token'
      path: '/join/$token'
      fullPath: '/join/$token'
      preLoaderRoute: typeof JoinTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unsubscribe/$token': {
      id: '/unsubscribe/$token'
      path: '/unsubscribe/$token'
      fullPath: '/unsubscribe/$token'
      preLoaderRoute: typeof UnsubscribeTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/$slug/': {
      id: '/_authenticated/$slug/'
      path: '/'
      fullPath: '/$slug/'
      preLoaderRoute: typeof AuthenticatedSlugIndexRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/attendance': {
      id: '/_authenticated/$slug/attendance'
      path: '/attendance'
      fullPath: '/$slug/attendance'
      preLoaderRoute: typeof AuthenticatedSlugAttendanceRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/deleted': {
      id: '/_authenticated/$slug/deleted'
      path: '/deleted'
      fullPath: '/$slug/deleted'
      preLoaderRoute: typeof AuthenticatedSlugDeletedRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/inbox': {
      id: '/_authenticated/$slug/inbox'
      path: '/inbox'
      fullPath: '/$slug/inbox'
      preLoaderRoute: typeof AuthenticatedSlugInboxRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/search': {
      id: '/_authenticated/$slug/search'
      path: '/search'
      fullPath: '/$slug/search'
      preLoaderRoute: typeof AuthenticatedSlugSearchRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/tasks': {
      id: '/_authenticated/$slug/tasks'
      path: '/tasks'
      fullPath: '/$slug/tasks'
      preLoaderRoute: typeof AuthenticatedSlugTasksRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/team': {
      id: '/_authenticated/$slug/team'
      path: '/team'
      fullPath: '/$slug/team'
      preLoaderRoute: typeof AuthenticatedSlugTeamRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/companies/new': {
      id: '/_authenticated/companies/new'
      path: '/companies/new'
      fullPath: '/companies/new'
      preLoaderRoute: typeof AuthenticatedCompaniesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/onboarding/invite': {
      id: '/_authenticated/onboarding/invite'
      path: '/invite'
      fullPath: '/onboarding/invite'
      preLoaderRoute: typeof AuthenticatedOnboardingInviteRouteImport
      parentRoute: typeof AuthenticatedOnboardingRoute
    }
    '/_authenticated/onboarding/profile': {
      id: '/_authenticated/onboarding/profile'
      path: '/profile'
      fullPath: '/onboarding/profile'
      preLoaderRoute: typeof AuthenticatedOnboardingProfileRouteImport
      parentRoute: typeof AuthenticatedOnboardingRoute
    }
    '/_authenticated/$slug/attendance/': {
      id: '/_authenticated/$slug/attendance/'
      path: '/'
      fullPath: '/$slug/attendance/'
      preLoaderRoute: typeof AuthenticatedSlugAttendanceIndexRouteImport
      parentRoute: typeof AuthenticatedSlugAttendanceRoute
    }
    '/_authenticated/$slug/attendance/leave': {
      id: '/_authenticated/$slug/attendance/leave'
      path: '/leave'
      fullPath: '/$slug/attendance/leave'
      preLoaderRoute: typeof AuthenticatedSlugAttendanceLeaveRouteImport
      parentRoute: typeof AuthenticatedSlugAttendanceRoute
    }
    '/_authenticated/$slug/attendance/month': {
      id: '/_authenticated/$slug/attendance/month'
      path: '/month'
      fullPath: '/$slug/attendance/month'
      preLoaderRoute: typeof AuthenticatedSlugAttendanceMonthRouteImport
      parentRoute: typeof AuthenticatedSlugAttendanceRoute
    }
    '/_authenticated/$slug/attendance/my-month': {
      id: '/_authenticated/$slug/attendance/my-month'
      path: '/my-month'
      fullPath: '/$slug/attendance/my-month'
      preLoaderRoute: typeof AuthenticatedSlugAttendanceMyMonthRouteImport
      parentRoute: typeof AuthenticatedSlugAttendanceRoute
    }
    '/_authenticated/$slug/invoices/': {
      id: '/_authenticated/$slug/invoices/'
      path: '/invoices'
      fullPath: '/$slug/invoices/'
      preLoaderRoute: typeof AuthenticatedSlugInvoicesIndexRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/invoices/$invoiceId': {
      id: '/_authenticated/$slug/invoices/$invoiceId'
      path: '/invoices/$invoiceId'
      fullPath: '/$slug/invoices/$invoiceId'
      preLoaderRoute: typeof AuthenticatedSlugInvoicesInvoiceIdRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/notes/': {
      id: '/_authenticated/$slug/notes/'
      path: '/notes'
      fullPath: '/$slug/notes/'
      preLoaderRoute: typeof AuthenticatedSlugNotesIndexRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/notes/$noteId': {
      id: '/_authenticated/$slug/notes/$noteId'
      path: '/notes/$noteId'
      fullPath: '/$slug/notes/$noteId'
      preLoaderRoute: typeof AuthenticatedSlugNotesNoteIdRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/payslips/': {
      id: '/_authenticated/$slug/payslips/'
      path: '/payslips'
      fullPath: '/$slug/payslips/'
      preLoaderRoute: typeof AuthenticatedSlugPayslipsIndexRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/payslips/$payslipId': {
      id: '/_authenticated/$slug/payslips/$payslipId'
      path: '/payslips/$payslipId'
      fullPath: '/$slug/payslips/$payslipId'
      preLoaderRoute: typeof AuthenticatedSlugPayslipsPayslipIdRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/payslips/mine': {
      id: '/_authenticated/$slug/payslips/mine'
      path: '/payslips/mine'
      fullPath: '/$slug/payslips/mine'
      preLoaderRoute: typeof AuthenticatedSlugPayslipsMineRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/projects/': {
      id: '/_authenticated/$slug/projects/'
      path: '/projects'
      fullPath: '/$slug/projects/'
      preLoaderRoute: typeof AuthenticatedSlugProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/projects/$projectId': {
      id: '/_authenticated/$slug/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/$slug/projects/$projectId'
      preLoaderRoute: typeof AuthenticatedSlugProjectsProjectIdRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
    '/_authenticated/$slug/team/': {
      id: '/_authenticated/$slug/team/'
      path: '/'
      fullPath: '/$slug/team/'
      preLoaderRoute: typeof AuthenticatedSlugTeamIndexRouteImport
      parentRoute: typeof AuthenticatedSlugTeamRoute
    }
    '/_authenticated/$slug/team/people': {
      id: '/_authenticated/$slug/team/people'
      path: '/people'
      fullPath: '/$slug/team/people'
      preLoaderRoute: typeof AuthenticatedSlugTeamPeopleRouteImport
      parentRoute: typeof AuthenticatedSlugTeamRoute
    }
    '/_authenticated/$slug/team_/$personId': {
      id: '/_authenticated/$slug/team_/$personId'
      path: '/team/$personId'
      fullPath: '/$slug/team/$personId'
      preLoaderRoute: typeof AuthenticatedSlugTeamPersonIdRouteImport
      parentRoute: typeof AuthenticatedSlugRoute
    }
  }
}

interface AuthenticatedSlugAttendanceRouteChildren {
  AuthenticatedSlugAttendanceLeaveRoute: typeof AuthenticatedSlugAttendanceLeaveRoute
  AuthenticatedSlugAttendanceMonthRoute: typeof AuthenticatedSlugAttendanceMonthRoute
  AuthenticatedSlugAttendanceMyMonthRoute: typeof AuthenticatedSlugAttendanceMyMonthRoute
  AuthenticatedSlugAttendanceIndexRoute: typeof AuthenticatedSlugAttendanceIndexRoute
}

const AuthenticatedSlugAttendanceRouteChildren: AuthenticatedSlugAttendanceRouteChildren =
  {
    AuthenticatedSlugAttendanceLeaveRoute:
      AuthenticatedSlugAttendanceLeaveRoute,
    AuthenticatedSlugAttendanceMonthRoute:
      AuthenticatedSlugAttendanceMonthRoute,
    AuthenticatedSlugAttendanceMyMonthRoute:
      AuthenticatedSlugAttendanceMyMonthRoute,
    AuthenticatedSlugAttendanceIndexRoute:
      AuthenticatedSlugAttendanceIndexRoute,
  }

const AuthenticatedSlugAttendanceRouteWithChildren =
  AuthenticatedSlugAttendanceRoute._addFileChildren(
    AuthenticatedSlugAttendanceRouteChildren,
  )

interface AuthenticatedSlugTeamRouteChildren {
  AuthenticatedSlugTeamPeopleRoute: typeof AuthenticatedSlugTeamPeopleRoute
  AuthenticatedSlugTeamIndexRoute: typeof AuthenticatedSlugTeamIndexRoute
}

const AuthenticatedSlugTeamRouteChildren: AuthenticatedSlugTeamRouteChildren = {
  AuthenticatedSlugTeamPeopleRoute: AuthenticatedSlugTeamPeopleRoute,
  AuthenticatedSlugTeamIndexRoute: AuthenticatedSlugTeamIndexRoute,
}

const AuthenticatedSlugTeamRouteWithChildren =
  AuthenticatedSlugTeamRoute._addFileChildren(
    AuthenticatedSlugTeamRouteChildren,
  )

interface AuthenticatedSlugRouteChildren {
  AuthenticatedSlugAttendanceRoute: typeof AuthenticatedSlugAttendanceRouteWithChildren
  AuthenticatedSlugDeletedRoute: typeof AuthenticatedSlugDeletedRoute
  AuthenticatedSlugInboxRoute: typeof AuthenticatedSlugInboxRoute
  AuthenticatedSlugSearchRoute: typeof AuthenticatedSlugSearchRoute
  AuthenticatedSlugTasksRoute: typeof AuthenticatedSlugTasksRoute
  AuthenticatedSlugTeamRoute: typeof AuthenticatedSlugTeamRouteWithChildren
  AuthenticatedSlugIndexRoute: typeof AuthenticatedSlugIndexRoute
  AuthenticatedSlugInvoicesInvoiceIdRoute: typeof AuthenticatedSlugInvoicesInvoiceIdRoute
  AuthenticatedSlugNotesNoteIdRoute: typeof AuthenticatedSlugNotesNoteIdRoute
  AuthenticatedSlugPayslipsPayslipIdRoute: typeof AuthenticatedSlugPayslipsPayslipIdRoute
  AuthenticatedSlugPayslipsMineRoute: typeof AuthenticatedSlugPayslipsMineRoute
  AuthenticatedSlugProjectsProjectIdRoute: typeof AuthenticatedSlugProjectsProjectIdRoute
  AuthenticatedSlugTeamPersonIdRoute: typeof AuthenticatedSlugTeamPersonIdRoute
  AuthenticatedSlugInvoicesIndexRoute: typeof AuthenticatedSlugInvoicesIndexRoute
  AuthenticatedSlugNotesIndexRoute: typeof AuthenticatedSlugNotesIndexRoute
  AuthenticatedSlugPayslipsIndexRoute: typeof AuthenticatedSlugPayslipsIndexRoute
  AuthenticatedSlugProjectsIndexRoute: typeof AuthenticatedSlugProjectsIndexRoute
}

const AuthenticatedSlugRouteChildren: AuthenticatedSlugRouteChildren = {
  AuthenticatedSlugAttendanceRoute:
    AuthenticatedSlugAttendanceRouteWithChildren,
  AuthenticatedSlugDeletedRoute: AuthenticatedSlugDeletedRoute,
  AuthenticatedSlugInboxRoute: AuthenticatedSlugInboxRoute,
  AuthenticatedSlugSearchRoute: AuthenticatedSlugSearchRoute,
  AuthenticatedSlugTasksRoute: AuthenticatedSlugTasksRoute,
  AuthenticatedSlugTeamRoute: AuthenticatedSlugTeamRouteWithChildren,
  AuthenticatedSlugIndexRoute: AuthenticatedSlugIndexRoute,
  AuthenticatedSlugInvoicesInvoiceIdRoute:
    AuthenticatedSlugInvoicesInvoiceIdRoute,
  AuthenticatedSlugNotesNoteIdRoute: AuthenticatedSlugNotesNoteIdRoute,
  AuthenticatedSlugPayslipsPayslipIdRoute:
    AuthenticatedSlugPayslipsPayslipIdRoute,
  AuthenticatedSlugPayslipsMineRoute: AuthenticatedSlugPayslipsMineRoute,
  AuthenticatedSlugProjectsProjectIdRoute:
    AuthenticatedSlugProjectsProjectIdRoute,
  AuthenticatedSlugTeamPersonIdRoute: AuthenticatedSlugTeamPersonIdRoute,
  AuthenticatedSlugInvoicesIndexRoute: AuthenticatedSlugInvoicesIndexRoute,
  AuthenticatedSlugNotesIndexRoute: AuthenticatedSlugNotesIndexRoute,
  AuthenticatedSlugPayslipsIndexRoute: AuthenticatedSlugPayslipsIndexRoute,
  AuthenticatedSlugProjectsIndexRoute: AuthenticatedSlugProjectsIndexRoute,
}

const AuthenticatedSlugRouteWithChildren =
  AuthenticatedSlugRoute._addFileChildren(AuthenticatedSlugRouteChildren)

interface AuthenticatedOnboardingRouteChildren {
  AuthenticatedOnboardingInviteRoute: typeof AuthenticatedOnboardingInviteRoute
  AuthenticatedOnboardingProfileRoute: typeof AuthenticatedOnboardingProfileRoute
}

const AuthenticatedOnboardingRouteChildren: AuthenticatedOnboardingRouteChildren =
  {
    AuthenticatedOnboardingInviteRoute: AuthenticatedOnboardingInviteRoute,
    AuthenticatedOnboardingProfileRoute: AuthenticatedOnboardingProfileRoute,
  }

const AuthenticatedOnboardingRouteWithChildren =
  AuthenticatedOnboardingRoute._addFileChildren(
    AuthenticatedOnboardingRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedSlugRoute: typeof AuthenticatedSlugRouteWithChildren
  AuthenticatedInvitesRoute: typeof AuthenticatedInvitesRoute
  AuthenticatedOnboardingRoute: typeof AuthenticatedOnboardingRouteWithChildren
  AuthenticatedCompaniesNewRoute: typeof AuthenticatedCompaniesNewRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedSlugRoute: AuthenticatedSlugRouteWithChildren,
  AuthenticatedInvitesRoute: AuthenticatedInvitesRoute,
  AuthenticatedOnboardingRoute: AuthenticatedOnboardingRouteWithChildren,
  AuthenticatedCompaniesNewRoute: AuthenticatedCompaniesNewRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ConsentRoute: ConsentRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  ITokenRoute: ITokenRoute,
  JoinTokenRoute: JoinTokenRoute,
  UnsubscribeTokenRoute: UnsubscribeTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
